export const PriceCell = ({ children }: { children?: number | null }) => {
  if (!children) {
    return <i>Error</i>;
  }

  return <div>{children.toFixed(2)} €</div>;
};
